import React from "react";

import {
  FormLabel,
  InputAdornment,
  TextField,
  TextareaAutosize,
} from "@mui/material";
import { useController } from "react-hook-form";

import { Theme } from "../../../Style/Theme";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";
import Label from "./Label";
import { Text2 } from "../Typography/Text/Text";

export const TextArea1 = ({
  control,
  label,
  name,
  width,
  size,
  readOnly,
  disabled,
  showLabel,
  fullWidth,
  icon,
  maxRows,
  minRows,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  return (
    <TextareaAutosize
      minRows={minRows || 3}
      maxRows={maxRows}
      fullWidth={fullWidth}
      disabled={disabled}
      variant="outlined"
      size={size ?? "small"}
      inputProps={{
        style: {
          width: width,
        },
      }}
      error={fieldState?.invalid}
      helperText={fieldState?.error?.message}
      placeholder={label}
      value={field.value}
      label={showLabel ? label : undefined}
      {...field}
      InputProps={{
        endAdornment: <InputAdornment position="end">{icon}</InputAdornment>,
      }}
    />
  );
};
export const TextArea2 = ({
  control,
  label,
  name,
  width,
  size,
  showPlaceholder,
  placeholder,
  disabled,
  color,
  showLabel,
  fullWidth,
  icon,
  maxRows,
  minRows,
  placeHolderColor,
  noColor,
  required,
  maxLength,
  showCharacterLength,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  return (
    <FormItemsWrap color={color}>
      <Label required={required} label={label} />
      <TextField
        multiline={minRows > 1}
        minRows={minRows || 3}
        maxRows={maxRows}
        fullWidth={fullWidth}
        disabled={disabled}
        variant="outlined"
        size={size ?? "small"}
        sx={{
          background: noColor ? undefined : color ? color : "#EBEBEB",
          "& input::placeholder": {
            color: placeHolderColor,
          },
          height: "100%",
          padding: "0px !important",
        }}
        inputProps={{
          style: {
            width: width,
          },
          maxLength: maxLength,
        }}
        error={fieldState?.invalid}
        helperText={
          showCharacterLength ? (
            <FormItemsWrap direction={"row"} justifyContent={"space-between"}>
              <div>{fieldState?.error?.message ?? ""}</div>
              <Text2
                color={"#717171"}
                text={`${(field.value || '').length}/${maxLength}`}
              />
            </FormItemsWrap>
          ) : (
            fieldState?.error?.message
          )
        }
        placeholder={showPlaceholder ? placeholder : undefined}
        value={field.value}
        label={showLabel ? label : undefined}
        {...field}
        InputProps={{
          endAdornment: <InputAdornment position="end">{icon}</InputAdornment>,
        }}
        FormHelperTextProps={{ component: 'div' }}
      />
    </FormItemsWrap>
  );
};
